module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_01@3x-de2a769a50c759708facb762e198f6cd.webp";